import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar, Box, ClickAwayListener, FormLabel, List, ListItem, Typography } from '@material-ui/core';
import CkEditor from '../../../Common/CkEditor/CkEditor';
import { OKRButton } from '../../../Common/OKRButton';
import { BottomArrowIcon } from '../../../../config/svg/CommonSvgIcon';
import { StatusIcon } from '../../../../config/svg/CommonSvg';
import { useDispatch } from 'react-redux';
import { Enums } from '../../../../config/enums';
import { feedbackResolveStatus } from '../../../../action/performanceImprovementPlan';
import { getGlobalTaskListDueDate, getTime, getUserName } from '../../../../config/utils';
import { ErrorIcon } from '../../../../config/svg/formElementIcons';
import AlertDialog from '../../../Common/Dialog';

export const FeedbackResolve = (props: any) => {
	const {
		resolveStatusTypes,
		loader,
		setLoader,
		showMsg,
		setIsFormEdited,
		handleTabChange,
		feedbackDetails,
		getFeedbackViewDetails,
		feedbackFormType,
	} = props;
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const statusDataObj = {
		feedbackId: 0,
		statusComment: '',
		feedbackStatusId: 0,
	};

	const [openStatusDropdown, setOpenStatusDropdown] = React.useState<Boolean>(false);
	const [resolveStatusData, setResolveStatusData] = useState<any>(statusDataObj);
	const [statusSelectionError, setStatusSelectionError] = useState<string>('');
	const [commentError, setCommentError] = useState<string>('');
	const [modalProps, setModalProps] = useState<any>({ open: false, event: {}, message: '' });

	const handleFeedbackDropdown = () => {
		setOpenStatusDropdown((prev: Boolean) => !prev);
	};
	const handleFeedbackClickAway = () => {
		setOpenStatusDropdown(false);
	};
	const handleResolveDropdownSelection = (event: any, statusData: any) => {
		handleFeedbackClickAway();
		setResolveStatusData({
			...resolveStatusData,
			feedbackStatusId: statusData?.feedbackStatusId,
			statusName: statusData?.name,
		});
		setStatusSelectionError('');
		setIsFormEdited(true);
	};
	const handleCancelClick = (e: any) => {
		setIsFormEdited(false);
		setResolveStatusData(statusDataObj);
		handleTabChange(e, Enums.ONE);
	};

	const handleCloseModal = (e: any, type: any) => {
		e.preventDefault();
		if (type === 1) {
			if (modalProps?.type === 'SubmitForm') {
				resolvePipAPICall();
			}
		}
		setModalProps({ open: false, type: '', message: '' });
	};
	const handleSubmitClick = () => {
		if (resolveStatusData?.feedbackStatusId) {
			if (resolveStatusData?.statusComment) {
				setModalProps({
					open: true,
					type: 'SubmitForm',
					message: t(
						'Once submitted, no changes can be made to the feedback details & submission details. Do you want to continue?'
					),
				});
			} else {
				setCommentError('Comment is required to Resolve feedback');
			}
		} else {
			setStatusSelectionError('Status selection is required to Resolve feedback');
		}
	};
	const resolvePipAPICall = async () => {
		try {
			setLoader(true);
			const requestPayload = {
				...resolveStatusData,
				feedbackId: feedbackDetails?.feedbackId || 0,
			};
			delete requestPayload.statusName;
			const response: any = await dispatch(feedbackResolveStatus(requestPayload));
			if (response?.data?.status === Enums.STATUS_SUCCESS) {
				const { messageList } = response?.data || {};
				const keys = messageList ? Object.keys(messageList) : [];
				const messages = keys && keys.length ? keys.map((item) => messageList[item]) : '';
				showMsg('success', messages || `Feedback status updated successfully`);
				setResolveStatusData(statusDataObj);
				getFeedbackViewDetails(feedbackDetails);
				// handleBackToListClick(pipFormType);
				// setLoader(false);
			} else {
				const { messageList } = response?.data || {};
				const keys = messageList ? Object.keys(messageList) : [];
				const messages = keys && keys.length ? keys.map((item) => messageList[item]) : '';
				showMsg('error', messages || `Error occurred while fetching personal development feedback.`);
				setLoader(false);
			}
			setIsFormEdited(false);
		} catch (error) {
			console.error(error);
			setLoader(false);
		}
	};

	return (
		<>
			<Box className='full-rectangular-card pip-view-resolve'>
				{feedbackFormType !== 'PIP' &&
				feedbackDetails?.timeframeStartDate &&
				feedbackDetails?.timeframeEndDate &&
				(feedbackDetails?.feedbackStatusId === Enums.ONE ||
					feedbackDetails?.feedbackStatusId === Enums.TWO ||
					feedbackDetails?.feedbackStatusId === Enums.THREE) ? (
					<Box className='resolve-edit-mode'>
						<FormLabel id='link-feedback' component='legend' className='form-label'>
							<StatusIcon />
							{t('statusLabel')}
							<i style={{ color: '#ff0000' }}>*</i>
						</FormLabel>
						<Box
							className={`ques-type-selection custom-type-dropdown-top helperText-bottom ${
								openStatusDropdown ? 'active' : ''
							}`}
						>
							<OKRButton
								className={'dropdown-button button-placeholder'}
								text={resolveStatusData?.statusName || '- Select -'}
								icon={<BottomArrowIcon />}
								handleClick={() => handleFeedbackDropdown()}
							></OKRButton>
							{statusSelectionError ? (
								<Typography className='error-field'>
									<ErrorIcon />
									{statusSelectionError || ''}
								</Typography>
							) : (
								<></>
							)}

							{openStatusDropdown && (
								<ClickAwayListener onClickAway={handleFeedbackClickAway}>
									<Box className='ques-type-dropdown'>
										<List component='div' disablePadding>
											{resolveStatusTypes
												?.filter((rec: any) => rec?.isResolvedStatus)
												?.map((item: any) => {
													return (
														<ListItem
															component='div'
															className={resolveStatusData?.feedbackStatusId === item?.feedbackStatusId ? 'active' : ''}
															key={`resolve_status_${item?.feedbackStatusId}`}
															onClick={(e: any) => handleResolveDropdownSelection(e, item)}
														>
															<Typography>{item?.name || ''}</Typography>
														</ListItem>
													);
												})}
										</List>
									</Box>
								</ClickAwayListener>
							)}
						</Box>
						{/* <CkEditor placeholder={t('expectationsAndPlan')} showEmoticons={true} value={''} /> */}
						<Box className='helperText-bottom'>
							<CkEditor
								placeholder={t('writeFinalComment')}
								showEmoticons={true}
								value={resolveStatusData?.statusComment || ''}
								handleEditorChange={(value: string) => {
									if (resolveStatusData?.statusComment !== value) {
										setResolveStatusData({
											...resolveStatusData,
											statusComment: value,
										});
										setCommentError('');
										setIsFormEdited(true);
									}
								}}
							/>
							{commentError ? <Typography className='error-field'>{commentError || ''}</Typography> : <></>}
						</Box>
						<Box className='action-btn'>
							<OKRButton
								disabled={Boolean(loader)}
								className={'btn-link'}
								id={'btn-cancel'}
								text={t('cancelBtn')}
								handleClick={handleCancelClick}
							/>
							<OKRButton
								disabled={Boolean(loader)}
								className={'btn-primary'}
								id={'btn-publish'}
								text={t('submit')}
								handleClick={handleSubmitClick}
							/>
						</Box>
					</Box>
				) : feedbackDetails?.feedbackStatusId > Enums.THREE ? (
					<>
						{feedbackDetails?.resolveDetails ? (
							<Box className='resolve-read-mode'>
								<Box className='user-info'>
									<Box className='user-img'>
										{feedbackDetails?.resolveDetails?.imagePath ? (
											<Avatar className='avatar-default' src={feedbackDetails?.resolveDetails?.imagePath} />
										) : (
											<Avatar className={'avatar-default'}>
												{getUserName({
													firstName: feedbackDetails?.resolveDetails?.firstName || '',
													lastName: feedbackDetails?.resolveDetails?.lastName || '',
													fullName: feedbackDetails?.resolveDetails?.fullName || '',
												})}
											</Avatar>
										)}
									</Box>
									<Box className='user-info-details'>
										<Typography variant='h4' className='font-weight-normal'>
											{`${feedbackDetails?.resolveDetails?.firstName || ''} ${
												feedbackDetails?.resolveDetails?.lastName || ''
											}`}
										</Typography>

										{feedbackDetails?.resolvedOn ? (
											<Typography variant='h6' className='font-weight-normal'>
												{`${getGlobalTaskListDueDate(feedbackDetails?.resolvedOn)} ${getTime(
													feedbackDetails?.resolvedOn
												)}`}
											</Typography>
										) : (
											<></>
										)}
									</Box>
								</Box>
								<Box className='long-text'>
									<Box
										dangerouslySetInnerHTML={{
											__html: feedbackDetails?.resolveDetails?.statusComment || '',
										}}
									></Box>
								</Box>
							</Box>
						) : (
							<></>
						)}
					</>
				) : (
					<></>
				)}
			</Box>

			{modalProps?.open && (
				<AlertDialog
					message={modalProps?.message || ''}
					handleCloseModal={handleCloseModal}
					modalOpen={modalProps.open}
				/>
			)}
		</>
	);
};
